import { Pipe, PipeTransform } from '@angular/core';
import { InKindAwardedItemApi, InKindItemToAwardOrPay } from '@features/in-kind/in-kind.typing';

@Pipe({
  name: 'gcCanRemoveInKindItem'
})
export class CanRemoveInKindItemPipe implements PipeTransform {

  transform (
    itemIdentification: string,
    isAward: boolean,
    paidItems: InKindItemToAwardOrPay[],
    alreadyPaidItems: InKindAwardedItemApi[],
    awardAndPaymentSame = false
  ) {
   if (isAward && !awardAndPaymentSame) {
     const paidIds = paidItems.map((item) => item.identification);
     const alreadyPaidIds = alreadyPaidItems.map((item) => item.itemIdentification);

     return !paidIds.includes(itemIdentification) &&
      !alreadyPaidIds.includes(itemIdentification);
   }

   return true;
  }
}
